var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillCompareOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync_alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.94 8.94L4 8L1.33333 10.6667L4 13.3333L4.94 12.3933L3.88667 11.3333H14V10H3.88667L4.94 8.94Z",
    fill: "#45B960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 7.06L12 8L14.6667 5.33333L12 2.66667L11.06 3.60667L12.1133 4.66667H2V6H12.1133L11.06 7.06Z",
    fill: "#45B960"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillCompareOptions);
export default __webpack_public_path__ + "static/media/pill_compare_options.c3e1cff076fa9cc1ef31868bc3528ad9.svg";
export { ForwardRef as ReactComponent };